export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FilesModal.vue?vue&type=template&id=23c3ce36&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/FilesModal.vue?vue&type=template&id=23c3ce36&scoped=true
// module id = 1967
// module chunks = 31